import { useParams } from "react-router-dom";
import { useSimulatorConfiguration } from "./useSimulatorConfiguration";
import { ConfigurationViewGuard } from "./parts/ConfigurationViewGuard";
import { TicketChannelEscalationConfiguration } from "./ticket-channel/TicketChannelEscalationConfiguration";
import { QuackChatChannelEscalationConfiguration } from "./quackchat-channel/QuackChatChannelEscalationConfiguration";

export function EscalationConfiguration() {
  const { simulatorId } = useParams();
  const { simulator } = useSimulatorConfiguration(simulatorId);

  const channel = simulator?.channel;

  return (
    <ConfigurationViewGuard view={"escalations"}>
      {channel === "autonomous_ticket_event" && (
        <TicketChannelEscalationConfiguration />
      )}
      {channel === "autonomous_quackchat" && (
        <QuackChatChannelEscalationConfiguration />
      )}
    </ConfigurationViewGuard>
  );
}
